import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { tasks as tasksLayout } from 'constants/layout'
import { apiTasksOverview } from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'

const enhance = compose(
  apiTasksOverview({
    overview: true
  }),
  connect(({ api }) => ({
    configuration: api.configuration
  }))
)

class Tasks extends Component {
  static propTypes = {
    children: PropTypes.any,
    tabs: PropTypes.any.isRequired,
    configuration: PropTypes.object.isRequired,
    tasks: PropTypes.object.isRequired,
    decoFilterMyOnly: PropTypes.bool,
    route: PropTypes.object
  }

  render () {
    const { tabs, children, tasks, configuration, decoFilterMyOnly, route } = this.props
    const overview = (decoFilterMyOnly && tasks.overview.overviewMyOnly)
      ? tasks.overview.overviewMyOnly
      : tasks.overview

    const tabsLinks = tasksLayout.tabs.map(item => {
      const getTaskSection = overview.list.filter(
        task => task.nameId === item.nameId
      )
      let getCount = null


      if (getTaskSection.length) {
        getCount = getTaskSection[0].value
      }

      return {
        ...item,
        progress: getCount
      }
    })

    return (
      <div>
        {React.cloneElement(tabs, {
          links: tabsLinks,
          overview,
          configuration
        })}
        {children}
        {renderRoutes(route.routes, this.props)}
      </div>
    )
  }
}

export default enhance(Tasks)
